<div class="toast">
  <button
    ctaClass="toast__close"
    app-vtmn-play-icon-button
    type="button"
    class="toast__close-button"
    [type]="ctaButtonType.Button"
    [variant]="ctaVariant"
    (click)="clickClose()"
  >
    <vtmn-play-icon
      [ariaLabel]="'toast.close_button' | translate"
      [name]="iconClose"
    ></vtmn-play-icon>
  </button>

  <app-tips
    [variant]="variant"
    [title]="header"
    [tips]="description"
    [icon]="iconName"
    [displayArrowIcon]="false"
  >
  </app-tips>
</div>
